<template>
	<div id="app">
		<nav-header />
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
		<nav-footer />

		<!-- 滚动到顶部按钮 -->
		<button v-show="showBackToTop" class="back-to-top" @click="scrollToTop" aria-label="Back to top">↑</button>
	</div>
</template>

<script>
import NavHeader from './components/NavHeader.vue';
import NavFooter from './components/NavFooter.vue';

export default {
	name: 'App',
	components: {
		NavHeader,
		NavFooter
	},
	data() {
		return {
			showBackToTop: false
		};
	},
	methods: {
		// 滚动到顶部
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth' // 平滑滚动
			});
		},
		// 监听滚动事件
		handleScroll() {
			this.showBackToTop = window.scrollY > 300; // 滚动超过 300px 显示按钮
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	}
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

body {
	padding: 0;
	background: #f8f9fa;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
/* 浮动按钮样式 */
.back-to-top {
	position: fixed;
	bottom: 30px;
	right: 30px;
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background-color: #007bff;
	color: white;
	border: none;
	cursor: pointer;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	transition: opacity 0.3s, transform 0.3s;
	z-index: 999;
}

.back-to-top:hover {
	background-color: #0056b3;
	transform: scale(1.1);
}
</style>
